<template>
  <div class="pb-75px">
    <main class="main reception">
      <div class="withdrawal-account" v-if="isExistingCustomer">
        <p class="title">비상금 지급 및 매출 반환 계좌:</p>
        <div class="account">
          <FormInput
            disabled
            name="bank"
            class="has-bank"
            type="text"
            v-bank-name
            placeholder="은행 선택"
            v-model="withdrawal.bank"
          />
          <FormInput
            name="accountno"
            class="has-account-no"
            type="tel"
            disabled
            v-model="withdrawal.account_number"
            placeholder="계좌번호 입력"
          />
        </div>
      </div>
      <form @submit.prevent="next()">
        <div class="section form-group">
          <span class="guide-text">등록 된 출금계좌(대출금입금)로<br /> 1원을 보내드렸습니다.<br />입금자로 표시된 숫자 3자리 또는 4자리를 입력해주세요.</span>
          <ExpireTime
            :expire-time="expireTime"
            @time-over="routeBack"
          />
          <div class="bottom">
            <div class="input-wrapper">
              <div class="input">
                <EditableInput
                class="verify-number-1"
                :content="verifyNumber1"
                @update="verifyNumber1 = $event"
                :max-length="1"
                @set-focus="setFocus('verify-number-2')"
                :tab-index="0"
              ></EditableInput>
              </div>
              <div class="input">
                <EditableInput
                class="verify-number-2"
                :content="verifyNumber2"
                @update="verifyNumber2 = $event"
                :max-length="1"
                @set-focus="setFocus('verify-number-3')"
                :tab-index="0"
              ></EditableInput>
              </div>
              <div class="input">
                <EditableInput
                class="verify-number-3"
                :content="verifyNumber3"
                @update="verifyNumber3 = $event"
                :max-length="1"
                @set-focus="setFocus('verify-number-4')"
                :tab-index="0"
              ></EditableInput>
              </div>
              <div class="input">
                <EditableInput
                class="verify-number-4"
                :content="verifyNumber4"
                @update="verifyNumber4 = $event"
                :max-length="1"
                :tab-index="0"
              ></EditableInput>
              </div>
            </div>
          </div>
        </div>
        <div class="section bottom">
          <button
            v-ripple
            class="button next-button"
            :disabled="!isVerfifyNumberFilled"
            type="submit"
          >
            확인
            <v-progress-circular
              style="padding-left: 15px;"
              size="24"
              v-if="isInProgress"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </button>
        </div>
      </form>
    </main>
  </div>
</template>
<script>
import AuthService from '@/service/auth/AuthService'
import UserService from '@/service/user/UserService'

import FormInput from '@/components/form/FormInput'
import EditableInput from './components/EditableInput'

import ExpireTime from './components/ExpireTime'

import { mapGetters } from 'vuex'

import moment from 'moment'

export default {
  components: {
    FormInput,
    EditableInput,
    ExpireTime
  },
  data() {
    return {
      isExistingCustomer: false,
      withdrawBankCode: null,
      user: {},
      withdrawal: {},
      verifyNumber1: '',
      verifyNumber2: '',
      verifyNumber3: '',
      verifyNumber4: '',
      isInProgress: false,
      expireTime: null,
    }
  },
  async created() {
    this.$store.commit('ui/headerTitle', '출금계좌 인증하기')
    this.user = await AuthService.getProfile()
    this.isExistingCustomer = await UserService.isExistingCustomer()

    this.withdrawal = this.user.withdrawal_account
    if (this.isExistingCustomer) {
      try {
        await UserService.putUserWithdrawalAccount(this.withdrawal)
        this.setExpireTime()
      } catch (e) {
        this.$swal.fire({
          html: '문제가 발생했습니다. 고객센터 02-6925-1788로 문의주세요.',
          icon: 'warning',
          confirmButtonText: '확인'
        })
      }
    } else {
      this.setExpireTime()
    }
  },
  mounted() {
    this.setFocus('verify-number-1')
  },
  computed: {
    ...mapGetters({
      getBanksKey: 'filter/getBanksKey'
    }),
    isVerfifyNumberFilled() {
      // 3 ~ 4 자리 입력받음
      // 보통은 4자리 웰컴저축은행은 3자리
      return this.verifyNumber1 && this.verifyNumber2 && this.verifyNumber3
    },
    verifyNumbers() {
      const { verifyNumber1, verifyNumber2, verifyNumber3, verifyNumber4 } = this
      return {
        verifyNumber1,
        verifyNumber2,
        verifyNumber3,
        verifyNumber4
      }
    }
  },
  watch: {
    verifyNumbers: function () {
      let verifyNumber = this.verifyNumber1 + this.verifyNumber2 + this.verifyNumber3 + this.verifyNumber4
      if (verifyNumber.length === 4) {
        this.next()
      }
    }
  },
  methods: {
    setExpireTime() {
      this.expireTime = moment()
        .add(5, 'minutes')
        .toDate()
    },
    async routeBack() {
      let swal = await this.$swal.fire({
        html: '인증시간이 초과됐습니다.<br />다시 출금계좌 인증하기를 진행해주세요.',
        icon: 'warning',
        confirmButtonText: '확인'
      })
      if (swal.isConfirmed) {
        this.$router.go(-1)
      }
    },
    setFocus(className) {
      if (className) {
        let p = document.querySelector('.' + className)
        let s = window.getSelection()
        let r = document.createRange()
        r.setStart(p, p.childElementCount)
        r.setEnd(p, p.childElementCount)
        s.removeAllRanges()
        s.addRange(r)
      }
    },
    async next() {
      if (this.isInProgress === true) {
        return
      }

      this.isInProgress = true

      try {
        let verifyNumber = this.verifyNumber1 + this.verifyNumber2 + this.verifyNumber3 + this.verifyNumber4
        let { data } = await UserService.postVerifyWithdrawalAccount(verifyNumber)
        if (data.result) {
          let confirm = await this.$swal.fire({
            html: '계좌 인증이 완료됐습니다.',
            confirmButtonText: '확인'
          })
          if (confirm.isConfirmed) {
            await AuthService.syncProfile()
            if (this.isExistingCustomer) {
              this.$router.push({ name: 'dashboard' })
            } else {
              this.$router.push({ name: 'my' })
            }
          }
        } else {
          let confirm = await this.$swal.fire({
            html: data.message,
            confirmButtonText: '확인'
          })
          if (confirm.isConfirmed) {
            this.initVerifyNumber()
          }
        }
      } catch (e) {
        if (e) {
          this.initVerifyNumber()
        }
        this.isInProgress = false
      }
    },
    initVerifyNumber() {
      this.verifyNumber1 = null
      this.verifyNumber2 = null
      this.verifyNumber3 = null
      this.verifyNumber4 = null
    }
  }
}
</script>
<style lang="scss" scoped>

.red-border {
  border-color: #ff1616;
}

.form-group {
  padding-bottom: 30px;
}

.bottom {
  width: 100%;
  margin-top: 1.5vh;
  .input-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;

    .input {
      width: 100%;
      max-width: 51px;
      border-radius: 4px;
      border: solid 1px #f2f2f2;
      background-color: #f2f2f2;
      height: 8.5vh;
      margin-left: 10px;
      margin-right: 10px;
      position: relative;
      div {
        font-size: 1.59rem;
        font-weight: 900;
        width: 25px;
        left: 25%;
        top: 22%;
        position: absolute;
        text-align: center;
      }
    }
  }
}

.withdrawal-account {
  padding-left: 20px;
  padding-right: 20px;
  .title {
    font-weight: 600;
    margin-bottom: 10px;
  }
}

.account {
  display: flex;
  border-radius: 4px;
  margin-bottom: 10px;

  input.has-account-no {
    flex: 2 2 65%;
    text-align: center;
    padding: 0;
    &::placeholder {
      color: #8a94a2;
      font-weight: normal;
    }
  }
  .has-bank:hover:enabled {
    color: #ffffff !important;
    background-color: #048cff;
  }
  .has-bank {
    cursor: pointer;
    text-align: center;
    color: #333333 !important;
    font-weight: 700;
    padding: 0;
    font-size: 16px;
    background-color: #ffffff;
    flex: 1 1 35%;
    border-radius: 4px;
    color: #8a94a2;
    border: 1px solid #d7e1ea;
    &::placeholder {
      color: #8a94a2;
      font-weight: normal;
    }
  }
  .has-bank:disabled {
    background-color: #ffffff !important;
    cursor: default;
  }
  :not(:last-child) {
    margin-right: 10px;
  }
}

.guide-text {
  display: block;
  font-size: 1.1rem;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 700;
}
</style>
